import { Button, Col, Container, Row } from "react-bootstrap";
import LoginButton from "../Auth/LoginButton";
import LogoutButton from "../Auth/LogoutButton";
import Profile from "../Auth/Profile";
import CallServerButton from "../Auth/CallServerButton";
import Subscribe from "../Checkout/Subscribe";
import { useAuth0 } from "@auth0/auth0-react";
import { auth0Config } from "../../Config/auth0Conifg";
import { callWhoami } from "../../Services/Serverless/callUsers";

export default function Authenticated() {
  const { getAccessTokenSilently } = useAuth0();

  const callServer = async () => {
    getAccessTokenSilently({
      authorizationParams: {
        audience: auth0Config.audience,
      },
    }).then((accessToken) => {
      console.log("logged in");
      callWhoami(accessToken);
    });
  };

  return (
    <div>
      <Container>
        <Row>
          <Col xs={9}>
            <Profile />
          </Col>
          <Col xs={3}>
            <div>
              <LoginButton /> / <LogoutButton />
            </div>
          </Col>
        </Row>
        <div>
          <Button onClick={callServer}>Call whoami</Button>
        </div>

        <CallServerButton />
        <Subscribe />
        <pre>{JSON.stringify(import.meta.env, null, 2)}</pre>
      </Container>
    </div>
  );
}
